import React, { useState } from 'react'
import styled from 'styled-components'
import { firestore, storage } from "../utils/firebase"
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import "./Styles/Style.css"


const DashboardComponent = () => {
    const [active, setActive] = useState(0);
    const [image, setImage] = useState({
        name: 'Select File format PNG & JPG'
    })
    const [categoryTabs, setCategoryTabs] = useState('Illustrations')
    const [formData, setFormData] = useState({
        embeddedCode: "",
        title: "",
        description: "",
        downloadUrl: "",
    });

    let name, value;
    const handleInputs = (e) => {
        name = e.target.name;
        value = e.target.value;

        setFormData({ ...formData, [name]: value });

    }
    const handleImage = (e) => {
        setImage(e.target.files[0])
    }
    const createItems = async (event) => {
        event.preventDefault();
        if(formData.embeddedCode.length >= 1 && image.name !== 'Select File format PNG & JPG'){
            const uploadTask = storage.ref(`images/${image.name}`).put(image);
            uploadTask.on(
                "state_changed",
                snapshot => {},
                error => {
                    console.log(error);
                },
                () => {
                    var regex = /(http|ftp|https):\/\/([\w\-]+(?:(?:\.[\w\-]+)+))([\w\-\.,@?^=%&amp;:/\+#]*[\w\-\@?^=%&amp;/\+#])?/

                    var url = formData.embeddedCode.match(regex)[0];
                    storage
                    .ref("images")
                    .child(image.name)
                    .getDownloadURL()
                    .then(imgUrl => {
                        const snap = firestore.collection('items').doc()
                        snap
                        .set({
                            img: imgUrl,
                            category: categoryTabs,
                            embeddedCode: url,
                            title: formData.title,
                            description: formData.description,
                            downloadUrl: formData.downloadUrl,
                            downloads: 0,
                            views: 0,
                            createdAt: Date.now()
                        })
                        toast.success('Item has been added!', {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: false,
                            progressStyle: {
                                backgroundColor: '#FFFFFF',
                            },
                            successIconColor: '#FFFFFF',
                            closeButton: false,
                            iconColor: '#FFFFFF',
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            });  
                    })
                }
            )
        }
       else if(formData.embeddedCode.length >= 1 ){
            var regex = /(http|ftp|https):\/\/([\w\-]+(?:(?:\.[\w\-]+)+))([\w\-\.,@?^=%&amp;:/\+#]*[\w\-\@?^=%&amp;/\+#])?/

                            var url = formData.embeddedCode.match(regex)[0];
                
                            const snap = firestore.collection('items').doc()
                            snap
                                .set({
                                    img: '',
                                    category: categoryTabs,
                                    embeddedCode: url,
                                    title: formData.title,
                                    description: formData.description,
                                    downloadUrl: formData.downloadUrl,
                                    downloads: 0,
                                    views: 0,
                                    createdAt: Date.now()
                                })
                toast.success('Item has been added!', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                progressStyle: {
                    backgroundColor: '#FFFFFF',
                },
                successIconColor: '#FFFFFF',
                closeButton: false,
                iconColor: '#FFFFFF',
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                });        
            } else{
                const uploadTask = storage.ref(`images/${image.name}`).put(image);
        uploadTask.on(
            "state_changed",
            snapshot => {},
            error => {
                console.log(error);
            },
            () => {
                storage
                .ref("images")
                .child(image.name)
                .getDownloadURL()
                .then(imgUrl => {
                    const snap = firestore.collection('items').doc()
                    snap
                    .set({
                        img: imgUrl,
                        category: categoryTabs,
                        embeddedCode: '',
                        title: formData.title,
                        description: formData.description,
                        downloadUrl: formData.downloadUrl,
                        downloads: 0,
                        views: 0,
                        createdAt: Date.now()
                    })
                    toast.success('Item has been added!', {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        progressStyle: {
                            backgroundColor: '#FFFFFF',
                        },
                        successIconColor: '#FFFFFF',
                        closeButton: false,
                        iconColor: '#FFFFFF',
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        });  
                })
            }
        )
            }
       
    }
    return (
        <Wrapper>
            <FormFieldsContainer onSubmit={createItems} >
            <div style={{width: '620px', display: 'flex',flexDirection: 'column',}}>
                <InputFieldHidden type="file"
                    id="file"
                    name="img"
                    onChange={handleImage} />
                <ImageSelect>
                    <PlaceHolder>
                    { 
                        image.name
                    }</PlaceHolder>
                    <SelectBtn for="file">Select</SelectBtn>
                </ImageSelect>
                <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-start', padding: '0 25px' }}>
                    <p>Or</p>
                </div>
                <InputField type="text" name="embeddedCode"
                    value={formData.embeddedCode}
                    onChange={handleInputs}
                    placeholder="Paste Embeded Code" />
                <InputField type="text" required
                    placeholder="Title"
                    name="title"
                    value={formData.title}
                    onChange={handleInputs}
                />
                <TextArea placeholder="Description" required
                    name="description"
                    value={formData.description}
                    onChange={handleInputs}
                />
                <InputField type="text"
                    placeholder="Download URL"
                    value={formData.downloadUrl}
                    onChange={handleInputs}
                    name="downloadUrl"
                />
                <BtnContainer >
                    <Btn type="submit" value="Update" />
                </BtnContainer>
        <ToastContainer
        toastStyle={{ backgroundColor: "#4C52EA", color: "#fff" }}
         />
         </div>
         <div style={{width: '380px', display: 'flex',flexDirection: 'column', alignItems: 'center'}}>
         <TabsContainer>
              {categoryData.map((item, i) => (
                <TabsBtn className={active === i ? "active" : ""} type="button" key={i} onClick={() => {
                    setCategoryTabs(item.title)
                    // Condition for toggling the lists.
                  // If current list is Selected
                  if (active === i) {
                    // change active to blank
                    setActive();
                  } else {
                    // change active to current index
                    setActive(i);
                  }
                    }} >
                {item.title}
                </TabsBtn>
              ))}
           </TabsContainer>
         </div>
            </FormFieldsContainer>


        </Wrapper>
    )
}
 
export default DashboardComponent
const categoryData = [
    { title: "Illustrations"},
    { title: "UI Kit"},
    { title: "Website"},
    { title: "Mobile"},
    { title: "Icons"}
]

const Wrapper = styled.div`
width: 100%;
height: 100%;
display: flex; 
justify-content: flex-end;
align-items: center;
padding: 3rem;
`
const FormFieldsContainer = styled.form`
width: 1000px;
margin-top: 150px;
display: flex;
flex-direction: row;
justify-content: flex-start;
`
const TextArea = styled.textarea`
width: 100%;
height: 250px;
background-color: #EFEFEF;
outline: none;
border: none;
border-radius: 5px;
font-family: Gilroy-Medium;
padding: 0.5em 0 0.5rem 2rem;
font-size: clamp(0.5rem, 4vw, 1.2rem);
margin: 1rem;
&::placeholder{
    color: #BFBFBF;

}
`
const InputField = styled.input`
width: 100%;
height: 58px;
background-color: #EFEFEF;
outline: none;
border: none;
border-radius: 5px;
font-family: Gilroy-Medium;
padding: 0.5em 0 0.5rem 2rem;
font-size: clamp(0.5rem, 4vw, 1.2rem);
margin: 1rem;
&::placeholder{
    color: #BFBFBF;

}
`
const InputFieldHidden = styled.input`
display: none;
width: 100%;
height: 58px;
background-color: #EFEFEF;
outline: none;
border: none;
border-radius: 5px;
font-family: Gilroy-Medium;
padding: 0.5em 0 0.5rem 2rem;
font-size: clamp(0.5rem, 4vw, 1.5rem);
margin: 1rem;
&::placeholder{
    color: #BFBFBF;

}
`
const Btn = styled.input`
outline: none;
border: none;
width: 180px;
height: 44px;
background-color: #4C52EA;
color: #fff;
border-radius: 5px;
font-size: clamp(0.5rem, 3vw, 1.2rem);
transition: 0.2s ease;

&:hover{
    cursor: pointer;
    transform: scale(1.1);
  z-index:100;
}
`
const ImageSelect = styled.div`
width: 100%;
height: 58px;
background-color: #EFEFEF;
border-radius: 5px;
font-family: Gilroy-Medium;
padding: 0.5em 0 0.5rem 2rem;
font-size: clamp(0.8rem, 4vw, 1.5rem);
margin: 1rem;
display: flex;
align-items: center;
justify-content: space-between;
`
const PlaceHolder = styled.p`
color: #ADADAD;;
font-family: Gilroy-Medium;
font-size: clamp(0.5rem, 4vw, 1.2rem);
`
const SelectBtn = styled.label`
display: flex;
align-items: center;
justify-content: center;
color: #ADADAD;
width: 167px;
height: 58px;
background-color: #4C52EA;
color: #fff;
border-radius: 5px;
font-family: Gilroy-Medium;
font-size: clamp(0.5rem, 4vw, 1.2rem);
margin-top: -5px;
cursor: pointer;
`

const BtnContainer = styled.div`
width: 100%;
display: flex;
justify-content: flex-end;
`
const TabsContainer = styled.div`
margin-top: 16px;
height: 540px;
width: 200px;
padding: 10px 0;
display: flex;
flex-direction: column;
align-items: center;
justify-content: flex-start;
border: 1px solid #E9E9E9;
border-radius: 5px;
`
const TabsBtn = styled.button`
margin: 2px 12px;
font-size: clamp(0.5rem, 3vw, 1.2rem);
font-family: Gilroy-Medium;
padding: 5px 18px;
border-radius: 5px;
outline: none;
border: none;
color: #000;
background-color: transparent;
cursor: pointer;
&:hover{
    background-color: #4C52EA;
    color: #fff;
}
&:active, :focus{
    background-color: #4C52EA;
    color: #fff;
    font-size: 20px;
}

`